/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerStreamResponseQueryResponse, ChatControllerStreamResponsePathParams, ChatControllerStreamResponse401, ChatControllerStreamResponse403 } from "../../models/chatController/ChatControllerStreamResponse";

function getChatControllerStreamResponseUrl(requestId: ChatControllerStreamResponsePathParams["requestId"]) {
  const res = { method: 'GET', url: `/api/v1/chat/stream/${requestId}` as const }  
  return res
}

/**
 * @summary Stream chat responses via Server-Sent Events
 * {@link /api/v1/chat/stream/:requestId}
 */
export async function chatControllerStreamResponse(requestId: ChatControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChatControllerStreamResponseQueryResponse, ResponseErrorConfig<ChatControllerStreamResponse401 | ChatControllerStreamResponse403>, unknown>({ method : "GET", url : getChatControllerStreamResponseUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}